import React from 'react'
import {useEffect, useState} from 'react'
import PortalKycHeatIndicator from './PortalKycHeatIndicator'
import {formatDateAsDaysAgo} from '../../utilities/daysFromDate'

const PortalDealCard = ({deal}) => {

    // useEffect(() => {
    //     console.log(deal.legs.sort((a, b) => {return a.legNumber < b.legNumber ? -1 : 1}))
    // })

    const updatedDate = new Date(deal.modified_Time)

    const legDateForDisplay = (d) => {
        const dateParts = d.split('-')

        return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
    }

    return (

        <div className={'portal__deal_card'}>
            <div className={'deal_card_header'}>
                <div className={'deal_card_timestamp'}>Updated {formatDateAsDaysAgo(updatedDate)}</div>
                <div className={'deal_card_kyc'}>
                    {deal.kyC_Heat && <PortalKycHeatIndicator kycHeat={deal.kyC_Heat} />}
                </div>
            </div>
            <div className={'deal_card_tripName'}>
                <h2>{deal.deal_Name}</h2>
            </div>
            <div className={'gold_divider'}></div>
                 <p>
                    <label>{deal.leadFullName.trim().length ? 'Lead' : 'Client'} name:</label> {deal.leadFullName.trim().length ? deal.leadFullName : deal.contactFullName}
                 </p>
                 <p>
                     Deal stage: {deal.stage}
                 </p>
                 {deal.ownerFullName && <p>
                     Deal Owner: {deal.ownerFullName}
                 </p>}
                 
                {deal.avinodeTripId && <p>
                    Trip Id: {deal.avinodeTripId}
                </p>}

                {deal.legs && <div>
                    <strong>Route</strong>
                    {deal.legs.sort((a, b) => {return a.legNumber < b.legNumber ? -1 : 1}).map((leg, index) => {
                        return (<p key={`${deal.id}-${index}`}>
                            Leg: {leg.legNumber}: {leg.legFrom} - {leg.legTo}<br/>
                            <em>{legDateForDisplay(leg.legDate)} {leg.legTime}</em>
                        </p>
                        )
                    })}
                </div>}


                {deal.quoteStats && 
                    <>
                        <p>Accepted: {deal.quoteStats.accepted}</p>
                        <p>Declined: {deal.quoteStats.declined}</p>
                        <p>Unanswered: {deal.quoteStats.unanswered}</p>
                    </>
                }
        </div>
    )
}

export default PortalDealCard